import type { ShoppingItem } from '../types';

export function ShoppingItemRow(props: {
  item: ShoppingItem;
  onToggle: () => void;
  onShowSafety: () => void;
}) {
  const it = props.item;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '8px 10px', background: 'white', borderRadius: 10, marginBottom: 4,
      opacity: it.checked ? 0.55 : 1,
    }}>
      <input
        type="checkbox" checked={it.checked} onChange={props.onToggle}
        style={{ width: 18, height: 18, accentColor: 'var(--pink-deep)' }}
        aria-label={`Toggle ${it.name}`}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 14, fontWeight: 600,
          textDecoration: it.checked ? 'line-through' : 'none',
        }}>
          {it.name}
          {it.bulk_candidate && (
            <span style={{
              marginLeft: 6, background: 'var(--amber-bg)', color: 'var(--amber-text)',
              fontSize: 10, padding: '1px 6px', borderRadius: 4, fontWeight: 600,
            }}>bulk</span>
          )}
          {it.added_manually && (
            <span style={{
              marginLeft: 6, background: 'var(--pink-tint)', color: 'var(--pink-primary)',
              fontSize: 10, padding: '1px 6px', borderRadius: 4, fontWeight: 600,
            }}>manual</span>
          )}
        </div>
        {it.quantity_hint && (
          <div style={{ fontSize: 11, color: 'var(--plum-soft)' }}>{it.quantity_hint}</div>
        )}
      </div>
      {it.safety_modification && (
        <button
          onClick={props.onShowSafety}
          style={{ background: 'transparent', border: 'none', fontSize: 16 }}
          aria-label={`Safety: ${it.safety_modification}`}
          title={it.safety_modification}
        >⚠</button>
      )}
    </div>
  );
}
